<ng-container *transloco="let t">
   {{ dataItem[columnOptions?.field] }} {{ t('Guidelines column name  (legal hub playbooks listening) - Guidelines') }}
</ng-container>